export default [
  {
    type: 3,
    title: "اعلان رویدادها",
    data: [
      {
        index: 0,
        name: "رویداد 1",
      },
      {
        index: 1,
        name: "رویداد 2",
      },
      {
        index: 2,
        name: "رویداد 3",
      },
      {
        index: 3,
        name: "رویداد 4",
      },
      {
        index: 4,
        name: "رویداد 5",
      },
      {
        index: 5,
        name: "رویداد 6",
      },
      {
        index: 6,
        name: "رویداد 7",
      },
      {
        index: 7,
        name: "رویداد 8",
      },
      {
        index: 8,
        name: "رویداد 9",
      },
      {
        index: 9,
        name: "رویداد 10",
      },
      {
        index: 10,
        name: "رویداد 11",
      },
      {
        index: 11,
        name: "رویداد 12",
      },
      {
        index: 12,
        name: "رویداد 13",
      },

      {
        index: 13,
        name: "رویداد 14",
      },
      {
        index: 14,
        name: "رویداد 15",
      },
      {
        index: 15,
        name: "رویداد 16",
      },
      {
        index: 16,
        name: "رویداد 17",
      },
      {
        index: 17,
        name: "رویداد 18",
      },
      {
        index: 18,
        name: "رویداد 19",
      },
      {
        index: 19,
        name: "رویداد 20",
      },
    ],
  },
  {
    type: 10,
    title: "اعلان ورودی‌ها",
    data: [
      {
        index: 0,
        name: "ورودی 1",
      },
      {
        index: 1,
        name: "ورودی 2",
      },
      {
        index: 2,
        name: "ورودی 3",
      },
      {
        index: 3,
        name: "ورودی 4",
      },
      {
        index: 4,
        name: "ورودی 5",
      },
      {
        index: 5,
        name: "ورودی 6",
      },
      {
        index: 6,
        name: "ورودی 7",
      },
      {
        index: 7,
        name: "ورودی 8",
      },
      {
        index: 8,
        name: "ورودی 9",
      },
      {
        index: 9,
        name: "ورودی 10",
      },
      {
        index: 10,
        name: "ورودی 11",
      },
      {
        index: 11,
        name: "ورودی 12",
      },
      {
        index: 12,
        name: "سناریو 1",
      },
      {
        index: 13,
        name: "سناریو 2",
      },
      {
        index: 14,
        name: "سناریو 3",
      },
      {
        index: 15,
        name: "سناریو 4",
      },
    ],
  },
  {
    type: 12,
    title: "اعلان ورودی‌ها",
    data: [
      {
        index: 0,
        name: "ورودی 1",
      },
      {
        index: 1,
        name: "ورودی 2",
      },
      {
        index: 2,
        name: "ورودی 3",
      },
      {
        index: 3,
        name: "ورودی 4",
      },
      {
        index: 4,
        name: "ورودی 5",
      },
      {
        index: 5,
        name: "ورودی 6",
      },
      {
        index: 6,
        name: "ورودی 7",
      },
      {
        index: 7,
        name: "ورودی 8",
      },
      {
        index: 8,
        name: "ورودی 9",
      },
      {
        index: 9,
        name: "ورودی 10",
      },
      {
        index: 10,
        name: "ورودی 11",
      },
      {
        index: 11,
        name: "ورودی 12",
      },
      {
        index: 12,
        name: "سناریو 1",
      },
      {
        index: 13,
        name: "سناریو 2",
      },
      {
        index: 14,
        name: "سناریو 3",
      },
      {
        index: 15,
        name: "سناریو 4",
      },
    ],
  },
];
